<template>
    <section class="section file-expired">
        <div class="container">
            <div class="columns is-centered is-vcentered is-flex-mobile">
                <div class="column">
                    <!-- <h1 class="title has-text-centered">Przepraszamy,<br>wskazany link wygasł.</h1> -->
                    <h1 class="title has-text-centered">{{$t('link-expired')}}</h1>
                    <p class="has-text-centered">
                       <a href.prevent="#" @click="$router.push('/')">{{$t('back-to-home-page')}}</a>
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    metaInfo: {
        meta: [
            {
                'name': 'robots',
                'content': 'noindex, nofollow'
            }
        ]
    }
}
</script>

<style scoped lang="sass">
.file-expired
    display: flex
    align-items: center
    min-height: calc(100vh - 207px)
</style>

